import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    p('initRulesForm');
    refresh();
    $('#rule_transfer_account_id').on('change', refresh);

    function refresh() {
      if ($('#rule_transfer_account_id').myGetNumValue()) {
        $('.rule_transfer_transaction_type').show(400);
      } else {
        $('.rule_transfer_transaction_type').hide(400);
      }
    }
  }
}